
import axios from '../axiosCall'
import Urls from "../endpoints";
import { ChangeStatusType, RestrictedCallType } from "../../types/RestrictedCall/Type";

export const getRestrictedCall = (params: RestrictedCallType) => {
    return axios.post(Urls.GetRestrictedCall(), params)
}



export const changeLineStatus = (params: ChangeStatusType) => {
    return axios.post(Urls.ChangeLineStatus(), params)
}